export const images = [
  "/img/user-placements/user-image-1.webp",
  "/img/user-placements/user-image-2.webp",
  "/img/user-placements/user-image-3.webp",
  "/img/user-placements/user-image-4.webp",
  "/img/user-placements/user-image-5.webp",
  "/img/user-placements/user-image-6.webp",
  "/img/user-placements/user-image-7.webp",
  "/img/user-placements/user-image-8.webp",
  "/img/user-placements/user-image-9.webp",
  "/img/user-placements/user-image-10.webp",
  "/img/user-placements/user-image-11.webp",
  "/img/user-placements/user-image-12.webp",
  "/img/user-placements/user-image-13.webp"
];


